import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function sendEmail(toEmail, subject, html, cc = []) {
  await addDoc(collection(db, "mail"), {
    to: toEmail,
    cc: cc,
    message: {
      subject: subject,
      html: html,
    },
  });
}